export const ACTION = {
    GET_COOKIE_POLICY_CONTENT: 'GET_COOKIE_POLICY_CONTENT',
};
